import type { AiSettings } from "@/entities/ai/types"

function csrfToken(): string {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta?.getAttribute("content") || ""
}

const headers = () => ({
  "Content-Type": "application/json",
  "X-CSRF-Token": csrfToken(),
})

export async function getAiSettings(workspaceSlug: string): Promise<AiSettings> {
  const res = await fetch(`/api/${workspaceSlug}/ai/settings`, { headers: headers() })
  if (!res.ok) throw new Error("Failed to fetch AI settings")
  return res.json()
}

export async function updateAiSettings(
  workspaceSlug: string,
  settings: Partial<{
    ai_provider: string
    ai_api_key: string
    ai_model: string
  }>
): Promise<void> {
  const res = await fetch(`/api/${workspaceSlug}/ai/settings`, {
    method: "PATCH",
    headers: headers(),
    body: JSON.stringify({ settings }),
  })
  if (!res.ok) throw new Error("Failed to update AI settings")
}

export async function reindexAi(workspaceSlug: string): Promise<void> {
  const res = await fetch(`/api/${workspaceSlug}/ai/settings/reindex`, {
    method: "POST",
    headers: headers(),
  })
  if (!res.ok) throw new Error("Failed to start reindex")
}
